import { useMatches, useParams } from "react-router-dom";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { Breadcrumbs, Box, useTheme } from "@mui/material";

export default function BreadcrumbsList() {
  const matches = useMatches();
  const params = useParams();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const colors = {
    border: isDarkMode ? "#334155" : "#e2e8f0",
    separator: isDarkMode ? "#64748b" : "#94a3b8",
    link: isDarkMode ? "#94a3b8" : "#64748b",
    linkHover: "#F97316",
    text: isDarkMode ? "#e2e8f0" : "#334155",
  };

  const crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb))
    .map((match) => match.handle.crumb(match.data));

  return (
    <Box
      sx={{
        mb: 2,
        pb: 2,
        borderBottom: `1px solid ${colors.border}`,
      }}
    >
      <Breadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: colors.separator,
          },
          "& a": {
            color: colors.link,
            textDecoration: "none",
            fontWeight: 500,
            fontSize: "0.85rem",
            transition: "color 0.15s",
            "&:hover": {
              color: colors.linkHover,
            },
          },
          "& span": {
            color: colors.text,
            fontWeight: 600,
            fontSize: "0.85rem",
          },
        }}
        separator={<NavigateNextIcon sx={{ fontSize: "1rem", color: colors.separator }} />}
        aria-label="breadcrumb"
      >
        {crumbs.map((crumb, idx) => {
          const currentCrumb = params?.id
            ? {
                ...crumb,
                props: {
                  ...crumb.props,
                  to: crumb.props.to.replace(":id", params?.id),
                  ...(crumb.props.to?.includes(":id")
                    ? { children: `${crumb.props.children} ${params?.id}` }
                    : {}),
                },
              }
            : crumb;

          return <span key={idx}>{currentCrumb}</span>;
        })}
      </Breadcrumbs>
    </Box>
  );
}
